/**
 * Notification realtime store (P3-S3 Doc 44).
 *
 * Khi WS push notification mới, hook bump `inboxVersion`. Components
 * (NotificationBell) watch version để re-fetch danh sách + count.
 *
 * Không lưu danh sách notifications ở đây — vẫn fetch qua API để giữ
 * consistency với polling fallback.
 */
import { create } from "zustand";

interface NotificationRealtimeState {
  /** Bump khi có notification mới (WS event hoặc polling) */
  inboxVersion: number;
  /** Trạng thái WS connection */
  wsStatus: "idle" | "connecting" | "connected" | "disconnected";
  /** Tin nhắn cuối cùng — optional, có thể dùng cho toast */
  lastNotification: {
    id?: string;
    title?: string;
    body?: string;
    receivedAt: number;
  } | null;
  bump: (msg?: { id?: string; title?: string; body?: string }) => void;
  setWsStatus: (s: NotificationRealtimeState["wsStatus"]) => void;
}

export const useNotificationRealtimeStore = create<NotificationRealtimeState>(
  (set) => ({
    inboxVersion: 0,
    wsStatus: "idle",
    lastNotification: null,
    bump: (msg) =>
      set((state) => ({
        inboxVersion: state.inboxVersion + 1,
        lastNotification: msg
          ? { ...msg, receivedAt: Date.now() }
          : state.lastNotification,
      })),
    setWsStatus: (s) => set({ wsStatus: s }),
  }),
);
